@if (!loading() && clients().length > 0) {
	<div class="fade-in container">
		<div class="list-container">
			<app-list
				[enableSelect]="true"
				[items]="clients()"
				[selectedUuid]="selectedUuid()"
				prefix="CLIENT"
				(onSelect)="select($event)"
			>
				<ng-template let-item>
					{{ item.active_text?.name || 'Missing active text...' }}
				</ng-template>
			</app-list>
		</div>
	</div>
}
